import { useEffect } from "react";
import toast from "react-hot-toast";

import useRecentSignups from "~/hooks/useRecentSignups";
import LandingPageRecentSignUpToast from "~/pages/info/components/LandingPageRecentSignUpToast";

interface RecentSignupsToastsProps {
	count?: number;
	delayBetweenToasts?: number;
	toastDuration?: number;
}

const RecentSignupsToasts = ({
	count = 5,
	delayBetweenToasts = 12000,
	toastDuration = 3000,
}: RecentSignupsToastsProps) => {
	const { recentSignups } = useRecentSignups({ count });

	useEffect(() => {
		if (!recentSignups?.length) return;

		const randomizedRecentSignups = [...recentSignups]
			.map((value) => ({ value, sort: Math.random() }))
			.sort((a, b) => a.sort - b.sort)
			.map(({ value }) => value);

		const timeouts: NodeJS.Timeout[] = [];

		randomizedRecentSignups.forEach((user, index) => {
			const timeout = setTimeout(
				() => {
					toast.custom(<LandingPageRecentSignUpToast user={user} />, {
						position: "bottom-left",
						duration: toastDuration,
						id: `signup-${user.id}`,
					});
				},
				4000 + index * delayBetweenToasts,
			);

			timeouts.push(timeout);
		});

		return () => timeouts.forEach(clearTimeout);
	}, [recentSignups, delayBetweenToasts, toastDuration]);

	return null;
};

export default RecentSignupsToasts;
